import success from "../assets/i18n/source/success-message/ENG.json";
import error from "../assets/i18n/source/error-message/ENG.json";

export const messagesType = {
  success: {
    type: 'success',
    client: 'sc',
    label: 'label',
    i18n: 'i18n'
  },
  error: {
    type: 'error',
    server: 'es',
    client: 'ec',
    label: 'label',
    i18n: 'i18n'
  },
  warning: {
    type: 'warning',
    label: 'label',
    i18n: 'i18n'
  }
}

export const commonErrorCode = {
  forbidMspOrg: 1000
}

export const defaultMessages = {
  success: null,
  error: null,
  warning: null,
};

export const messageKeyList = [
  ...Object.keys(success),
  ...Object.keys(error)
];

export const messageKeyPrefix = {
  e: {
    c: 'ERROR_CODE_C_',
    s: 'ERROR_CODE_S_'
  },
  s: {
    c: 'SUCCESS_CODE_C_'
  }
};